import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  title: '',
  link: '',
};

const travelRequirementsSlice = createSlice({
  name: 'travelRequirements',
  initialState,
  reducers: {},
});

export default travelRequirementsSlice.reducer;
